//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './FormsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetFormByIdFormsQueryParameters = {
  id: number;
};

export type GetFormHistoryByIdFormsQueryParameters = {
  formResultId: number;
};

export type GetFormsFormsQueryParameters = {
  studyId: number;
  ids?: number[] | null | null;
  type?: string | null | null;
};

export type ProcessResultsFormsMutationParameters = {
  files?: Types.FileParameter[] | null | undefined ; 
  dto?: Types.ProcessFormResultDto | undefined ; 
};

export type PatchResultsFormsMutationParameters = {
  newFiles?: Types.FileParameter[] | null | undefined ; 
  dto?: Types.UpdateFormResultDto | undefined ; 
};

export type GetFormResultsFormsQueryParameters = {
  studyId: number;
  formConfigId?: number | null | null;
  formTypes?: string[] | null | null;
  patientId?: string | null | null;
  patientUniqueId?: string | null | null;
  lastFormResultVersionOnly?: boolean | null | null;
  lifecycleStates?: Types.FormLifecycleState[] | null | null;
  limit?: number | null | null;
  orderByDataKey?: string | null | null;
  dataKeyDateFilter_DataKey?: string | null;
  dataKeyDateFilter_Since?: Date | null | null;
  dataKeyDateFilter_Until?: Date | null | null;
  formResultId?: number | null | null;
};

export type PatchAndSubmitFormFormsMutationParameters = {
  newFiles?: Types.FileParameter[] | null | undefined ; 
  dto?: Types.UpdateFormResultDto | undefined ; 
};

export type GetFormResultDatesFormsQueryParameters = {
  patientId?: string | null;
  formConfigId?: number | null | null;
  formType?: string | null | null;
  byDataKey?: string | null | null;
};

export type GetFormResultByIdFormsQueryParameters = {
  resultId: number;
};

export type UploadFileFormsMutationParameters = {
  file?: Types.FileParameter | null | undefined ; 
};

    
export function getFormByIdUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/forms/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getFormByIdDefaultOptions: UseQueryOptions<Types.FormDto, unknown, Types.FormDto> = {
  queryFn: __getFormById,
};
export function getGetFormByIdDefaultOptions(): UseQueryOptions<Types.FormDto, unknown, Types.FormDto> {
  return getFormByIdDefaultOptions;
};
export function setGetFormByIdDefaultOptions(options: UseQueryOptions<Types.FormDto, unknown, Types.FormDto>) {
  getFormByIdDefaultOptions = options;
}

export function getFormByIdQueryKey(id: number): QueryKey;
export function getFormByIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetFormByIdFormsQueryParameters;

    return trimArrayEnd([
        'FormsClient',
        'getFormById',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'FormsClient',
        'getFormById',
        ...params
      ]);
  }
}
function __getFormById(context: QueryFunctionContext) {
  return Client.getFormById(
      context.queryKey[2] as number    );
}

export function useGetFormByIdQuery<TSelectData = Types.FormDto, TError = unknown>(dto: GetFormByIdFormsQueryParameters, options?: UseQueryOptions<Types.FormDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Return Form UI config by given ID.
 * @param id Form Id.
 * @return Returns given form
 */
export function useGetFormByIdQuery<TSelectData = Types.FormDto, TError = unknown>(id: number, options?: UseQueryOptions<Types.FormDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetFormByIdQuery<TSelectData = Types.FormDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FormDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetFormByIdFormsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.FormDto, TError, TSelectData>({
    queryFn: __getFormById,
    queryKey: getFormByIdQueryKey(id),
    ...getFormByIdDefaultOptions as unknown as UseQueryOptions<Types.FormDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Return Form UI config by given ID.
 * @param id Form Id.
 * @return Returns given form
 */
export function setGetFormByIdData(queryClient: QueryClient, updater: (data: Types.FormDto | undefined) => Types.FormDto, id: number) {
  queryClient.setQueryData(getFormByIdQueryKey(id),
    updater
  );
}

/**
 * Return Form UI config by given ID.
 * @param id Form Id.
 * @return Returns given form
 */
export function setGetFormByIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FormDto | undefined) => Types.FormDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function patchFormUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/forms/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchFormMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'patchForm',
      id as any,
    ]);
}

/**
 * Update form UI config
 * @param id Id of the form config to update.
 * @param dto New version of the form config.
 */
export function usePatchFormMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.FormDto, unknown, Types.PatchFormConfigDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormDto, unknown, Types.PatchFormConfigDto, TContext> {
  const key = patchFormMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.PatchFormConfigDto) => Client.patchForm(id, dto), {...options, mutationKey: key});
}
  
    
export function removeFormUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/forms/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeFormMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'removeForm',
      id as any,
    ]);
}

/**
 * Deletes form UI config by given ID.
 * @param id Id of the form
 */
export function useRemoveFormMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeFormMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removeForm(id), {...options, mutationKey: key});
}
  
    
export function getFormHistoryByIdUrl(formResultId: number): string {
  let url_ = getBaseUrl() + "/api/forms/{formResultId}/history";
if (formResultId === undefined || formResultId === null)
  throw new Error("The parameter 'formResultId' must be defined.");
url_ = url_.replace("{formResultId}", encodeURIComponent("" + formResultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getFormHistoryByIdDefaultOptions: UseQueryOptions<Types.FormHistoryDto, unknown, Types.FormHistoryDto> = {
  queryFn: __getFormHistoryById,
};
export function getGetFormHistoryByIdDefaultOptions(): UseQueryOptions<Types.FormHistoryDto, unknown, Types.FormHistoryDto> {
  return getFormHistoryByIdDefaultOptions;
};
export function setGetFormHistoryByIdDefaultOptions(options: UseQueryOptions<Types.FormHistoryDto, unknown, Types.FormHistoryDto>) {
  getFormHistoryByIdDefaultOptions = options;
}

export function getFormHistoryByIdQueryKey(formResultId: number): QueryKey;
export function getFormHistoryByIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { formResultId,  } = params[0] as GetFormHistoryByIdFormsQueryParameters;

    return trimArrayEnd([
        'FormsClient',
        'getFormHistoryById',
        formResultId as any,
      ]);
  } else {
    return trimArrayEnd([
        'FormsClient',
        'getFormHistoryById',
        ...params
      ]);
  }
}
function __getFormHistoryById(context: QueryFunctionContext) {
  return Client.getFormHistoryById(
      context.queryKey[2] as number    );
}

export function useGetFormHistoryByIdQuery<TSelectData = Types.FormHistoryDto, TError = unknown>(dto: GetFormHistoryByIdFormsQueryParameters, options?: UseQueryOptions<Types.FormHistoryDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Return Form history of changes by given ID.
 * @return Returns given form history
 */
export function useGetFormHistoryByIdQuery<TSelectData = Types.FormHistoryDto, TError = unknown>(formResultId: number, options?: UseQueryOptions<Types.FormHistoryDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetFormHistoryByIdQuery<TSelectData = Types.FormHistoryDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FormHistoryDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let formResultId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ formResultId,  } = params[0] as GetFormHistoryByIdFormsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [formResultId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.FormHistoryDto, TError, TSelectData>({
    queryFn: __getFormHistoryById,
    queryKey: getFormHistoryByIdQueryKey(formResultId),
    ...getFormHistoryByIdDefaultOptions as unknown as UseQueryOptions<Types.FormHistoryDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Return Form history of changes by given ID.
 * @return Returns given form history
 */
export function setGetFormHistoryByIdData(queryClient: QueryClient, updater: (data: Types.FormHistoryDto | undefined) => Types.FormHistoryDto, formResultId: number) {
  queryClient.setQueryData(getFormHistoryByIdQueryKey(formResultId),
    updater
  );
}

/**
 * Return Form history of changes by given ID.
 * @return Returns given form history
 */
export function setGetFormHistoryByIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FormHistoryDto | undefined) => Types.FormHistoryDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getFormsUrl(studyId: number, ids?: number[] | null | undefined, type?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/forms?";
  if (studyId === undefined || studyId === null)
    throw new Error("The parameter 'studyId' must be defined and cannot be null.");
  else
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
if (ids !== undefined && ids !== null)
    ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
if (type !== undefined && type !== null)
    url_ += "Type=" + encodeURIComponent("" + type) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getFormsDefaultOptions: UseQueryOptions<Types.FormDto[], unknown, Types.FormDto[]> = {
  queryFn: __getForms,
};
export function getGetFormsDefaultOptions(): UseQueryOptions<Types.FormDto[], unknown, Types.FormDto[]> {
  return getFormsDefaultOptions;
};
export function setGetFormsDefaultOptions(options: UseQueryOptions<Types.FormDto[], unknown, Types.FormDto[]>) {
  getFormsDefaultOptions = options;
}

export function getFormsQueryKey(dto: GetFormsFormsQueryParameters): QueryKey;
export function getFormsQueryKey(studyId: number, ids?: number[] | null | undefined, type?: string | null | undefined): QueryKey;
export function getFormsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, ids, type,  } = params[0] as GetFormsFormsQueryParameters;

    return trimArrayEnd([
        'FormsClient',
        'getForms',
        studyId as any,
        ids as any,
        type as any,
      ]);
  } else {
    return trimArrayEnd([
        'FormsClient',
        'getForms',
        ...params
      ]);
  }
}
function __getForms(context: QueryFunctionContext) {
  return Client.getForms(
      context.queryKey[2] as number,       context.queryKey[3] as number[] | null | undefined,       context.queryKey[4] as string | null | undefined    );
}

export function useGetFormsQuery<TSelectData = Types.FormDto[], TError = unknown>(dto: GetFormsFormsQueryParameters, options?: UseQueryOptions<Types.FormDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets forms available for logged in user.
 * @param ids (optional) 
 * @param type (optional) 
 */
export function useGetFormsQuery<TSelectData = Types.FormDto[], TError = unknown>(studyId: number, ids?: number[] | null | undefined, type?: string | null | undefined, options?: UseQueryOptions<Types.FormDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetFormsQuery<TSelectData = Types.FormDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FormDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let ids: any = undefined;
  let type: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, ids, type,  } = params[0] as GetFormsFormsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, ids, type, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.FormDto[], TError, TSelectData>({
    queryFn: __getForms,
    queryKey: getFormsQueryKey(studyId, ids, type),
    ...getFormsDefaultOptions as unknown as UseQueryOptions<Types.FormDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Gets forms available for logged in user.
 * @param ids (optional) 
 * @param type (optional) 
 */
export function setGetFormsData(queryClient: QueryClient, updater: (data: Types.FormDto[] | undefined) => Types.FormDto[], studyId: number, ids?: number[] | null | undefined, type?: string | null | undefined) {
  queryClient.setQueryData(getFormsQueryKey(studyId, ids, type),
    updater
  );
}

/**
 * Gets forms available for logged in user.
 * @param ids (optional) 
 * @param type (optional) 
 */
export function setGetFormsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FormDto[] | undefined) => Types.FormDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createFormUrl(): string {
  let url_ = getBaseUrl() + "/api/forms";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createFormMutationKey(): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'createForm',
    ]);
}

/**
 * Creates new UI form config.
 */
export function useCreateFormMutation<TContext>(options?: Omit<UseMutationOptions<Types.FormDto, unknown, Types.CreateFormConfigDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormDto, unknown, Types.CreateFormConfigDto, TContext> {
  const key = createFormMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.CreateFormConfigDto) => Client.createForm(dto), {...options, mutationKey: key});
}
  
    
export function processResultsUrl(awaitScoreCalculation?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/forms/results?";
if (awaitScoreCalculation === null)
    throw new Error("The parameter 'awaitScoreCalculation' cannot be null.");
else if (awaitScoreCalculation !== undefined)
    url_ += "awaitScoreCalculation=" + encodeURIComponent("" + awaitScoreCalculation) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function processResultsMutationKey(awaitScoreCalculation?: boolean | undefined): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'processResults',
      awaitScoreCalculation as any,
    ]);
}

/**
 * Process (saves) results of forms
 * @param awaitScoreCalculation (optional) The flag indicates scoring should be awaited or not
 * @param files (optional) 
 * @param dto (optional) 
 */
export function useProcessResultsMutation<TContext>(awaitScoreCalculation?: boolean | undefined, options?: Omit<UseMutationOptions<Types.FormResultDto, unknown, ProcessResultsFormsMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormResultDto, unknown, ProcessResultsFormsMutationParameters, TContext> {
  const key = processResultsMutationKey(awaitScoreCalculation);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((processResultsFormsMutationParameters: ProcessResultsFormsMutationParameters) => Client.processResults(awaitScoreCalculation, processResultsFormsMutationParameters.files, processResultsFormsMutationParameters.dto), {...options, mutationKey: key});
}
  
    
export function patchResultsUrl(awaitScoreCalculation?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/forms/results?";
if (awaitScoreCalculation === null)
    throw new Error("The parameter 'awaitScoreCalculation' cannot be null.");
else if (awaitScoreCalculation !== undefined)
    url_ += "awaitScoreCalculation=" + encodeURIComponent("" + awaitScoreCalculation) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchResultsMutationKey(awaitScoreCalculation?: boolean | undefined): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'patchResults',
      awaitScoreCalculation as any,
    ]);
}

/**
 * Updates results of forms
 * @param awaitScoreCalculation (optional) The flag indicates scoring should be awaited or not
 * @param newFiles (optional) 
 * @param dto (optional) 
 */
export function usePatchResultsMutation<TContext>(awaitScoreCalculation?: boolean | undefined, options?: Omit<UseMutationOptions<Types.FormResultDto, unknown, PatchResultsFormsMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormResultDto, unknown, PatchResultsFormsMutationParameters, TContext> {
  const key = patchResultsMutationKey(awaitScoreCalculation);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((patchResultsFormsMutationParameters: PatchResultsFormsMutationParameters) => Client.patchResults(awaitScoreCalculation, patchResultsFormsMutationParameters.newFiles, patchResultsFormsMutationParameters.dto), {...options, mutationKey: key});
}
  
    
export function getFormResultsUrl(studyId: number, formConfigId?: number | null | undefined, formTypes?: string[] | null | undefined, patientId?: string | null | undefined, patientUniqueId?: string | null | undefined, lastFormResultVersionOnly?: boolean | null | undefined, lifecycleStates?: Types.FormLifecycleState[] | null | undefined, limit?: number | null | undefined, orderByDataKey?: string | null | undefined, dataKeyDateFilter_DataKey?: string | undefined, dataKeyDateFilter_Since?: Date | null | undefined, dataKeyDateFilter_Until?: Date | null | undefined, formResultId?: number | null | undefined): string {
  let url_ = getBaseUrl() + "/api/forms/results?";
  if (studyId === undefined || studyId === null)
    throw new Error("The parameter 'studyId' must be defined and cannot be null.");
  else
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
if (formConfigId !== undefined && formConfigId !== null)
    url_ += "FormConfigId=" + encodeURIComponent("" + formConfigId) + "&";
if (formTypes !== undefined && formTypes !== null)
    formTypes && formTypes.forEach(item => { url_ += "FormTypes=" + encodeURIComponent("" + item) + "&"; });
if (patientId !== undefined && patientId !== null)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (patientUniqueId !== undefined && patientUniqueId !== null)
    url_ += "PatientUniqueId=" + encodeURIComponent("" + patientUniqueId) + "&";
if (lastFormResultVersionOnly !== undefined && lastFormResultVersionOnly !== null)
    url_ += "LastFormResultVersionOnly=" + encodeURIComponent("" + lastFormResultVersionOnly) + "&";
if (lifecycleStates !== undefined && lifecycleStates !== null)
    lifecycleStates && lifecycleStates.forEach(item => { url_ += "LifecycleStates=" + encodeURIComponent("" + item) + "&"; });
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (orderByDataKey !== undefined && orderByDataKey !== null)
    url_ += "OrderByDataKey=" + encodeURIComponent("" + orderByDataKey) + "&";
if (dataKeyDateFilter_DataKey === null)
    throw new Error("The parameter 'dataKeyDateFilter_DataKey' cannot be null.");
else if (dataKeyDateFilter_DataKey !== undefined)
    url_ += "DataKeyDateFilter.DataKey=" + encodeURIComponent("" + dataKeyDateFilter_DataKey) + "&";
if (dataKeyDateFilter_Since !== undefined && dataKeyDateFilter_Since !== null)
    url_ += "DataKeyDateFilter.Since=" + encodeURIComponent(dataKeyDateFilter_Since ? "" + Types.formatDate(dataKeyDateFilter_Since) : "") + "&";
if (dataKeyDateFilter_Until !== undefined && dataKeyDateFilter_Until !== null)
    url_ += "DataKeyDateFilter.Until=" + encodeURIComponent(dataKeyDateFilter_Until ? "" + Types.formatDate(dataKeyDateFilter_Until) : "") + "&";
if (formResultId !== undefined && formResultId !== null)
    url_ += "FormResultId=" + encodeURIComponent("" + formResultId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getFormResultsDefaultOptions: UseQueryOptions<Types.PagedResultOfFormResultDto, unknown, Types.PagedResultOfFormResultDto> = {
  queryFn: __getFormResults,
};
export function getGetFormResultsDefaultOptions(): UseQueryOptions<Types.PagedResultOfFormResultDto, unknown, Types.PagedResultOfFormResultDto> {
  return getFormResultsDefaultOptions;
};
export function setGetFormResultsDefaultOptions(options: UseQueryOptions<Types.PagedResultOfFormResultDto, unknown, Types.PagedResultOfFormResultDto>) {
  getFormResultsDefaultOptions = options;
}

export function getFormResultsQueryKey(dto: GetFormResultsFormsQueryParameters): QueryKey;
export function getFormResultsQueryKey(studyId: number, formConfigId?: number | null | undefined, formTypes?: string[] | null | undefined, patientId?: string | null | undefined, patientUniqueId?: string | null | undefined, lastFormResultVersionOnly?: boolean | null | undefined, lifecycleStates?: Types.FormLifecycleState[] | null | undefined, limit?: number | null | undefined, orderByDataKey?: string | null | undefined, dataKeyDateFilter_DataKey?: string | undefined, dataKeyDateFilter_Since?: Date | null | undefined, dataKeyDateFilter_Until?: Date | null | undefined, formResultId?: number | null | undefined): QueryKey;
export function getFormResultsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, formConfigId, formTypes, patientId, patientUniqueId, lastFormResultVersionOnly, lifecycleStates, limit, orderByDataKey, dataKeyDateFilter_DataKey, dataKeyDateFilter_Since, dataKeyDateFilter_Until, formResultId,  } = params[0] as GetFormResultsFormsQueryParameters;

    return trimArrayEnd([
        'FormsClient',
        'getFormResults',
        studyId as any,
        formConfigId as any,
        formTypes as any,
        patientId as any,
        patientUniqueId as any,
        lastFormResultVersionOnly as any,
        lifecycleStates as any,
        limit as any,
        orderByDataKey as any,
        dataKeyDateFilter_DataKey as any,
        dataKeyDateFilter_Since as any,
        dataKeyDateFilter_Until as any,
        formResultId as any,
      ]);
  } else {
    return trimArrayEnd([
        'FormsClient',
        'getFormResults',
        ...params
      ]);
  }
}
function __getFormResults(context: QueryFunctionContext) {
  return Client.getFormResults(
      context.queryKey[2] as number,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as string[] | null | undefined,       context.queryKey[5] as string | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as boolean | null | undefined,       context.queryKey[8] as Types.FormLifecycleState[] | null | undefined,       context.queryKey[9] as number | null | undefined,       context.queryKey[10] as string | null | undefined,       context.queryKey[11] as string | undefined,       context.queryKey[12] as Date | null | undefined,       context.queryKey[13] as Date | null | undefined,       context.queryKey[14] as number | null | undefined    );
}

export function useGetFormResultsQuery<TSelectData = Types.PagedResultOfFormResultDto, TError = unknown>(dto: GetFormResultsFormsQueryParameters, options?: UseQueryOptions<Types.PagedResultOfFormResultDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns form results.
 * @param formConfigId (optional) Related form config id.
 * @param formTypes (optional) Related form config type.
 * @param patientId (optional) Related patient id.
 * @param patientUniqueId (optional) The unique id of the related patient
 * @param lastFormResultVersionOnly (optional) Get only the last form result version
 * @param lifecycleStates (optional) If not null, only those form result versions will be returned whose lifecycle state is contained here.
 * @param limit (optional) Get requested amount of results.
 * @param orderByDataKey (optional) Order results by value with specified data key
 * @param dataKeyDateFilter_DataKey (optional) Data key name (form field name) by which date-range filter will be applied
 * @param dataKeyDateFilter_Since (optional) Date from which the filter will be applied.
 * @param dataKeyDateFilter_Until (optional) Date until form results will be filtered bu given DataKey.
 * @param formResultId (optional) Related form result id.
 */
export function useGetFormResultsQuery<TSelectData = Types.PagedResultOfFormResultDto, TError = unknown>(studyId: number, formConfigId?: number | null | undefined, formTypes?: string[] | null | undefined, patientId?: string | null | undefined, patientUniqueId?: string | null | undefined, lastFormResultVersionOnly?: boolean | null | undefined, lifecycleStates?: Types.FormLifecycleState[] | null | undefined, limit?: number | null | undefined, orderByDataKey?: string | null | undefined, dataKeyDateFilter_DataKey?: string | undefined, dataKeyDateFilter_Since?: Date | null | undefined, dataKeyDateFilter_Until?: Date | null | undefined, formResultId?: number | null | undefined, options?: UseQueryOptions<Types.PagedResultOfFormResultDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetFormResultsQuery<TSelectData = Types.PagedResultOfFormResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfFormResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let formConfigId: any = undefined;
  let formTypes: any = undefined;
  let patientId: any = undefined;
  let patientUniqueId: any = undefined;
  let lastFormResultVersionOnly: any = undefined;
  let lifecycleStates: any = undefined;
  let limit: any = undefined;
  let orderByDataKey: any = undefined;
  let dataKeyDateFilter_DataKey: any = undefined;
  let dataKeyDateFilter_Since: any = undefined;
  let dataKeyDateFilter_Until: any = undefined;
  let formResultId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, formConfigId, formTypes, patientId, patientUniqueId, lastFormResultVersionOnly, lifecycleStates, limit, orderByDataKey, dataKeyDateFilter_DataKey, dataKeyDateFilter_Since, dataKeyDateFilter_Until, formResultId,  } = params[0] as GetFormResultsFormsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, formConfigId, formTypes, patientId, patientUniqueId, lastFormResultVersionOnly, lifecycleStates, limit, orderByDataKey, dataKeyDateFilter_DataKey, dataKeyDateFilter_Since, dataKeyDateFilter_Until, formResultId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PagedResultOfFormResultDto, TError, TSelectData>({
    queryFn: __getFormResults,
    queryKey: getFormResultsQueryKey(studyId, formConfigId, formTypes, patientId, patientUniqueId, lastFormResultVersionOnly, lifecycleStates, limit, orderByDataKey, dataKeyDateFilter_DataKey, dataKeyDateFilter_Since, dataKeyDateFilter_Until, formResultId),
    ...getFormResultsDefaultOptions as unknown as UseQueryOptions<Types.PagedResultOfFormResultDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns form results.
 * @param formConfigId (optional) Related form config id.
 * @param formTypes (optional) Related form config type.
 * @param patientId (optional) Related patient id.
 * @param patientUniqueId (optional) The unique id of the related patient
 * @param lastFormResultVersionOnly (optional) Get only the last form result version
 * @param lifecycleStates (optional) If not null, only those form result versions will be returned whose lifecycle state is contained here.
 * @param limit (optional) Get requested amount of results.
 * @param orderByDataKey (optional) Order results by value with specified data key
 * @param dataKeyDateFilter_DataKey (optional) Data key name (form field name) by which date-range filter will be applied
 * @param dataKeyDateFilter_Since (optional) Date from which the filter will be applied.
 * @param dataKeyDateFilter_Until (optional) Date until form results will be filtered bu given DataKey.
 * @param formResultId (optional) Related form result id.
 */
export function setGetFormResultsData(queryClient: QueryClient, updater: (data: Types.PagedResultOfFormResultDto | undefined) => Types.PagedResultOfFormResultDto, studyId: number, formConfigId?: number | null | undefined, formTypes?: string[] | null | undefined, patientId?: string | null | undefined, patientUniqueId?: string | null | undefined, lastFormResultVersionOnly?: boolean | null | undefined, lifecycleStates?: Types.FormLifecycleState[] | null | undefined, limit?: number | null | undefined, orderByDataKey?: string | null | undefined, dataKeyDateFilter_DataKey?: string | undefined, dataKeyDateFilter_Since?: Date | null | undefined, dataKeyDateFilter_Until?: Date | null | undefined, formResultId?: number | null | undefined) {
  queryClient.setQueryData(getFormResultsQueryKey(studyId, formConfigId, formTypes, patientId, patientUniqueId, lastFormResultVersionOnly, lifecycleStates, limit, orderByDataKey, dataKeyDateFilter_DataKey, dataKeyDateFilter_Since, dataKeyDateFilter_Until, formResultId),
    updater
  );
}

/**
 * Returns form results.
 * @param formConfigId (optional) Related form config id.
 * @param formTypes (optional) Related form config type.
 * @param patientId (optional) Related patient id.
 * @param patientUniqueId (optional) The unique id of the related patient
 * @param lastFormResultVersionOnly (optional) Get only the last form result version
 * @param lifecycleStates (optional) If not null, only those form result versions will be returned whose lifecycle state is contained here.
 * @param limit (optional) Get requested amount of results.
 * @param orderByDataKey (optional) Order results by value with specified data key
 * @param dataKeyDateFilter_DataKey (optional) Data key name (form field name) by which date-range filter will be applied
 * @param dataKeyDateFilter_Since (optional) Date from which the filter will be applied.
 * @param dataKeyDateFilter_Until (optional) Date until form results will be filtered bu given DataKey.
 * @param formResultId (optional) Related form result id.
 */
export function setGetFormResultsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfFormResultDto | undefined) => Types.PagedResultOfFormResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function skipFormResultUrl(): string {
  let url_ = getBaseUrl() + "/api/forms/results/skip";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function skipFormResultMutationKey(): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'skipFormResult',
    ]);
}

export function useSkipFormResultMutation<TContext>(options?: Omit<UseMutationOptions<Types.FormResultDto, unknown, Types.SkipFormResultDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormResultDto, unknown, Types.SkipFormResultDto, TContext> {
  const key = skipFormResultMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.SkipFormResultDto) => Client.skipFormResult(dto), {...options, mutationKey: key});
}
  
    
export function skipAllFormsOnRouteProgressStepUrl(): string {
  let url_ = getBaseUrl() + "/api/forms/results/skipStep";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function skipAllFormsOnRouteProgressStepMutationKey(): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'skipAllFormsOnRouteProgressStep',
    ]);
}

export function useSkipAllFormsOnRouteProgressStepMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.SkipAllFormsOnStepDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SkipAllFormsOnStepDto, TContext> {
  const key = skipAllFormsOnRouteProgressStepMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.SkipAllFormsOnStepDto) => Client.skipAllFormsOnRouteProgressStep(dto), {...options, mutationKey: key});
}
  
    
export function markFormResultAsSkippedUrl(formResultId: number): string {
  let url_ = getBaseUrl() + "/api/forms/results/{formResultId}/markAsSkipped";
if (formResultId === undefined || formResultId === null)
  throw new Error("The parameter 'formResultId' must be defined.");
url_ = url_.replace("{formResultId}", encodeURIComponent("" + formResultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function markFormResultAsSkippedMutationKey(formResultId: number): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'markFormResultAsSkipped',
      formResultId as any,
    ]);
}

export function useMarkFormResultAsSkippedMutation<TContext>(formResultId: number, options?: Omit<UseMutationOptions<Types.FormResultDto, unknown, Types.MarkFormResultAsSkippedDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormResultDto, unknown, Types.MarkFormResultAsSkippedDto, TContext> {
  const key = markFormResultAsSkippedMutationKey(formResultId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.MarkFormResultAsSkippedDto) => Client.markFormResultAsSkipped(formResultId, dto), {...options, mutationKey: key});
}
  
    
export function revokeFormResultSkipUrl(formResultId: number): string {
  let url_ = getBaseUrl() + "/api/forms/results/{formResultId}/revokeSkip";
if (formResultId === undefined || formResultId === null)
  throw new Error("The parameter 'formResultId' must be defined.");
url_ = url_.replace("{formResultId}", encodeURIComponent("" + formResultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function revokeFormResultSkipMutationKey(formResultId: number): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'revokeFormResultSkip',
      formResultId as any,
    ]);
}

export function useRevokeFormResultSkipMutation<TContext>(formResultId: number, options?: Omit<UseMutationOptions<Types.FormResultDto, unknown, { [key: string]: any; }, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormResultDto, unknown, { [key: string]: any; }, TContext> {
  const key = revokeFormResultSkipMutationKey(formResultId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((initialValue: { [key: string]: any; }) => Client.revokeFormResultSkip(formResultId, initialValue), {...options, mutationKey: key});
}
  
    
export function markFormResultAsDraftUrl(resultId: number): string {
  let url_ = getBaseUrl() + "/api/forms/results/{resultId}/markAsDraft";
if (resultId === undefined || resultId === null)
  throw new Error("The parameter 'resultId' must be defined.");
url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function markFormResultAsDraftMutationKey(resultId: number): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'markFormResultAsDraft',
      resultId as any,
    ]);
}

export function useMarkFormResultAsDraftMutation<TContext>(resultId: number, options?: Omit<UseMutationOptions<Types.FormResultVersionDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormResultVersionDto, unknown, void, TContext> {
  const key = markFormResultAsDraftMutationKey(resultId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.markFormResultAsDraft(resultId), {...options, mutationKey: key});
}
  
    
export function approveFormResultUrl(resultId: number): string {
  let url_ = getBaseUrl() + "/api/forms/results/{resultId}/approve";
if (resultId === undefined || resultId === null)
  throw new Error("The parameter 'resultId' must be defined.");
url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function approveFormResultMutationKey(resultId: number): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'approveFormResult',
      resultId as any,
    ]);
}

export function useApproveFormResultMutation<TContext>(resultId: number, options?: Omit<UseMutationOptions<Types.FormResultVersionDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormResultVersionDto, unknown, void, TContext> {
  const key = approveFormResultMutationKey(resultId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.approveFormResult(resultId), {...options, mutationKey: key});
}
  
    
export function approveAllSkippedFormsOnRouteProgressStepUrl(patientId?: string | undefined, stepName?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/forms/results/approveStep?";
if (patientId === null)
    throw new Error("The parameter 'patientId' cannot be null.");
else if (patientId !== undefined)
    url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
if (stepName === null)
    throw new Error("The parameter 'stepName' cannot be null.");
else if (stepName !== undefined)
    url_ += "stepName=" + encodeURIComponent("" + stepName) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function approveAllSkippedFormsOnRouteProgressStepMutationKey(patientId?: string | undefined, stepName?: string | undefined): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'approveAllSkippedFormsOnRouteProgressStep',
      patientId as any,
      stepName as any,
    ]);
}

export function useApproveAllSkippedFormsOnRouteProgressStepMutation<TContext>(patientId?: string | undefined, stepName?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = approveAllSkippedFormsOnRouteProgressStepMutationKey(patientId, stepName);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.approveAllSkippedFormsOnRouteProgressStep(patientId, stepName), {...options, mutationKey: key});
}
  
    
export function recallFormResultApprovalUrl(resultId: number): string {
  let url_ = getBaseUrl() + "/api/forms/results/{resultId}/recallApproval";
if (resultId === undefined || resultId === null)
  throw new Error("The parameter 'resultId' must be defined.");
url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function recallFormResultApprovalMutationKey(resultId: number): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'recallFormResultApproval',
      resultId as any,
    ]);
}

export function useRecallFormResultApprovalMutation<TContext>(resultId: number, options?: Omit<UseMutationOptions<Types.FormResultVersionDto, unknown, Types.RecallFormResultApprovalDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormResultVersionDto, unknown, Types.RecallFormResultApprovalDto, TContext> {
  const key = recallFormResultApprovalMutationKey(resultId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.RecallFormResultApprovalDto) => Client.recallFormResultApproval(resultId, dto), {...options, mutationKey: key});
}
  
    
export function submitFormUrl(resultId: number): string {
  let url_ = getBaseUrl() + "/api/forms/results/{resultId}/submit";
if (resultId === undefined || resultId === null)
  throw new Error("The parameter 'resultId' must be defined.");
url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function submitFormMutationKey(resultId: number): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'submitForm',
      resultId as any,
    ]);
}

export function useSubmitFormMutation<TContext>(resultId: number, options?: Omit<UseMutationOptions<Types.FormResultDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormResultDto, unknown, void, TContext> {
  const key = submitFormMutationKey(resultId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.submitForm(resultId), {...options, mutationKey: key});
}
  
    
export function patchAndSubmitFormUrl(awaitScoreCalculation?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/forms/results/patchAndSubmit?";
if (awaitScoreCalculation === null)
    throw new Error("The parameter 'awaitScoreCalculation' cannot be null.");
else if (awaitScoreCalculation !== undefined)
    url_ += "awaitScoreCalculation=" + encodeURIComponent("" + awaitScoreCalculation) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchAndSubmitFormMutationKey(awaitScoreCalculation?: boolean | undefined): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'patchAndSubmitForm',
      awaitScoreCalculation as any,
    ]);
}

export function usePatchAndSubmitFormMutation<TContext>(awaitScoreCalculation?: boolean | undefined, options?: Omit<UseMutationOptions<Types.FormResultDto, unknown, PatchAndSubmitFormFormsMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormResultDto, unknown, PatchAndSubmitFormFormsMutationParameters, TContext> {
  const key = patchAndSubmitFormMutationKey(awaitScoreCalculation);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((patchAndSubmitFormFormsMutationParameters: PatchAndSubmitFormFormsMutationParameters) => Client.patchAndSubmitForm(awaitScoreCalculation, patchAndSubmitFormFormsMutationParameters.newFiles, patchAndSubmitFormFormsMutationParameters.dto), {...options, mutationKey: key});
}
  
    
export function getFormResultDatesUrl(patientId?: string | undefined, formConfigId?: number | null | undefined, formType?: string | null | undefined, byDataKey?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/forms/results/dates?";
if (patientId === null)
    throw new Error("The parameter 'patientId' cannot be null.");
else if (patientId !== undefined)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (formConfigId !== undefined && formConfigId !== null)
    url_ += "FormConfigId=" + encodeURIComponent("" + formConfigId) + "&";
if (formType !== undefined && formType !== null)
    url_ += "FormType=" + encodeURIComponent("" + formType) + "&";
if (byDataKey !== undefined && byDataKey !== null)
    url_ += "ByDataKey=" + encodeURIComponent("" + byDataKey) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getFormResultDatesDefaultOptions: UseQueryOptions<Types.FormResultDatesDto, unknown, Types.FormResultDatesDto> = {
  queryFn: __getFormResultDates,
};
export function getGetFormResultDatesDefaultOptions(): UseQueryOptions<Types.FormResultDatesDto, unknown, Types.FormResultDatesDto> {
  return getFormResultDatesDefaultOptions;
};
export function setGetFormResultDatesDefaultOptions(options: UseQueryOptions<Types.FormResultDatesDto, unknown, Types.FormResultDatesDto>) {
  getFormResultDatesDefaultOptions = options;
}

export function getFormResultDatesQueryKey(dto: GetFormResultDatesFormsQueryParameters): QueryKey;
export function getFormResultDatesQueryKey(patientId?: string | undefined, formConfigId?: number | null | undefined, formType?: string | null | undefined, byDataKey?: string | null | undefined): QueryKey;
export function getFormResultDatesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId, formConfigId, formType, byDataKey,  } = params[0] as GetFormResultDatesFormsQueryParameters;

    return trimArrayEnd([
        'FormsClient',
        'getFormResultDates',
        patientId as any,
        formConfigId as any,
        formType as any,
        byDataKey as any,
      ]);
  } else {
    return trimArrayEnd([
        'FormsClient',
        'getFormResultDates',
        ...params
      ]);
  }
}
function __getFormResultDates(context: QueryFunctionContext) {
  return Client.getFormResultDates(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as string | null | undefined,       context.queryKey[5] as string | null | undefined    );
}

export function useGetFormResultDatesQuery<TSelectData = Types.FormResultDatesDto, TError = unknown>(dto: GetFormResultDatesFormsQueryParameters, options?: UseQueryOptions<Types.FormResultDatesDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns array of dates by requested form type.
If special data key is not provided - will take results by "filled at" date field.
 * @param patientId (optional) Related patient id.
 * @param formConfigId (optional) Related form config id.
 * @param formType (optional) Related form config type.
 * @param byDataKey (optional) Process results dates by value with specified data key
 */
export function useGetFormResultDatesQuery<TSelectData = Types.FormResultDatesDto, TError = unknown>(patientId?: string | undefined, formConfigId?: number | null | undefined, formType?: string | null | undefined, byDataKey?: string | null | undefined, options?: UseQueryOptions<Types.FormResultDatesDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetFormResultDatesQuery<TSelectData = Types.FormResultDatesDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FormResultDatesDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let patientId: any = undefined;
  let formConfigId: any = undefined;
  let formType: any = undefined;
  let byDataKey: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId, formConfigId, formType, byDataKey,  } = params[0] as GetFormResultDatesFormsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, formConfigId, formType, byDataKey, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.FormResultDatesDto, TError, TSelectData>({
    queryFn: __getFormResultDates,
    queryKey: getFormResultDatesQueryKey(patientId, formConfigId, formType, byDataKey),
    ...getFormResultDatesDefaultOptions as unknown as UseQueryOptions<Types.FormResultDatesDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns array of dates by requested form type.
If special data key is not provided - will take results by "filled at" date field.
 * @param patientId (optional) Related patient id.
 * @param formConfigId (optional) Related form config id.
 * @param formType (optional) Related form config type.
 * @param byDataKey (optional) Process results dates by value with specified data key
 */
export function setGetFormResultDatesData(queryClient: QueryClient, updater: (data: Types.FormResultDatesDto | undefined) => Types.FormResultDatesDto, patientId?: string | undefined, formConfigId?: number | null | undefined, formType?: string | null | undefined, byDataKey?: string | null | undefined) {
  queryClient.setQueryData(getFormResultDatesQueryKey(patientId, formConfigId, formType, byDataKey),
    updater
  );
}

/**
 * Returns array of dates by requested form type.
If special data key is not provided - will take results by "filled at" date field.
 * @param patientId (optional) Related patient id.
 * @param formConfigId (optional) Related form config id.
 * @param formType (optional) Related form config type.
 * @param byDataKey (optional) Process results dates by value with specified data key
 */
export function setGetFormResultDatesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FormResultDatesDto | undefined) => Types.FormResultDatesDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getFormResultByIdUrl(resultId: number): string {
  let url_ = getBaseUrl() + "/api/forms/result/{resultId}";
if (resultId === undefined || resultId === null)
  throw new Error("The parameter 'resultId' must be defined.");
url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getFormResultByIdDefaultOptions: UseQueryOptions<Types.FormResultDto, unknown, Types.FormResultDto> = {
  queryFn: __getFormResultById,
};
export function getGetFormResultByIdDefaultOptions(): UseQueryOptions<Types.FormResultDto, unknown, Types.FormResultDto> {
  return getFormResultByIdDefaultOptions;
};
export function setGetFormResultByIdDefaultOptions(options: UseQueryOptions<Types.FormResultDto, unknown, Types.FormResultDto>) {
  getFormResultByIdDefaultOptions = options;
}

export function getFormResultByIdQueryKey(resultId: number): QueryKey;
export function getFormResultByIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { resultId,  } = params[0] as GetFormResultByIdFormsQueryParameters;

    return trimArrayEnd([
        'FormsClient',
        'getFormResultById',
        resultId as any,
      ]);
  } else {
    return trimArrayEnd([
        'FormsClient',
        'getFormResultById',
        ...params
      ]);
  }
}
function __getFormResultById(context: QueryFunctionContext) {
  return Client.getFormResultById(
      context.queryKey[2] as number    );
}

export function useGetFormResultByIdQuery<TSelectData = Types.FormResultDto, TError = unknown>(dto: GetFormResultByIdFormsQueryParameters, options?: UseQueryOptions<Types.FormResultDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns form result and form UI config by id.
 * @param resultId Form result id.
 */
export function useGetFormResultByIdQuery<TSelectData = Types.FormResultDto, TError = unknown>(resultId: number, options?: UseQueryOptions<Types.FormResultDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetFormResultByIdQuery<TSelectData = Types.FormResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FormResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let resultId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ resultId,  } = params[0] as GetFormResultByIdFormsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [resultId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.FormResultDto, TError, TSelectData>({
    queryFn: __getFormResultById,
    queryKey: getFormResultByIdQueryKey(resultId),
    ...getFormResultByIdDefaultOptions as unknown as UseQueryOptions<Types.FormResultDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns form result and form UI config by id.
 * @param resultId Form result id.
 */
export function setGetFormResultByIdData(queryClient: QueryClient, updater: (data: Types.FormResultDto | undefined) => Types.FormResultDto, resultId: number) {
  queryClient.setQueryData(getFormResultByIdQueryKey(resultId),
    updater
  );
}

/**
 * Returns form result and form UI config by id.
 * @param resultId Form result id.
 */
export function setGetFormResultByIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FormResultDto | undefined) => Types.FormResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function recalculateScoreUrl(formResultId: number, versionNumber: number, minorVersionNumber: number): string {
  let url_ = getBaseUrl() + "/api/forms/recalculateScore?";
  if (formResultId === undefined || formResultId === null)
    throw new Error("The parameter 'formResultId' must be defined and cannot be null.");
  else
    url_ += "formResultId=" + encodeURIComponent("" + formResultId) + "&";
  if (versionNumber === undefined || versionNumber === null)
    throw new Error("The parameter 'versionNumber' must be defined and cannot be null.");
  else
    url_ += "versionNumber=" + encodeURIComponent("" + versionNumber) + "&";
  if (minorVersionNumber === undefined || minorVersionNumber === null)
    throw new Error("The parameter 'minorVersionNumber' must be defined and cannot be null.");
  else
    url_ += "minorVersionNumber=" + encodeURIComponent("" + minorVersionNumber) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function recalculateScoreMutationKey(formResultId: number, versionNumber: number, minorVersionNumber: number): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'recalculateScore',
      formResultId as any,
      versionNumber as any,
      minorVersionNumber as any,
    ]);
}

/**
 * Trigger recalculation form score
 */
export function useRecalculateScoreMutation<TContext>(formResultId: number, versionNumber: number, minorVersionNumber: number, options?: Omit<UseMutationOptions<Types.FormResultVersionDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FormResultVersionDto, unknown, void, TContext> {
  const key = recalculateScoreMutationKey(formResultId, versionNumber, minorVersionNumber);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.recalculateScore(formResultId, versionNumber, minorVersionNumber), {...options, mutationKey: key});
}
  
    
export function uploadFileUrl(): string {
  let url_ = getBaseUrl() + "/api/forms/UploadFile";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function uploadFileMutationKey(): MutationKey {
  return trimArrayEnd([
      'FormsClient',
      'uploadFile',
    ]);
}

/**
 * Upload file
 * @param file (optional) 
 */
export function useUploadFileMutation<TContext>(options?: Omit<UseMutationOptions<Types.FileDto, unknown, UploadFileFormsMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.FileDto, unknown, UploadFileFormsMutationParameters, TContext> {
  const key = uploadFileMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((uploadFileFormsMutationParameters: UploadFileFormsMutationParameters) => Client.uploadFile(uploadFileFormsMutationParameters.file), {...options, mutationKey: key});
}